import { MenuSectionStoryblok } from "@/types/storyblok-blok-types";
import clsx from "clsx";
import styles from "./header-bloks.module.css";

export const SectionTabs = ({
  sections,
  activeUid,
  setActiveUid,
}: {
  sections: MenuSectionStoryblok[];
  activeUid: string | null;
  setActiveUid: (uid: string) => void;
}) => {
  return (
    <div className={styles.sectionTabs}>
      {sections.map((section) => (
        <button
          key={section._uid}
          className={clsx(
            styles.sectionTab,
            section._uid === activeUid && styles.activeTab
          )}
          onClick={() => setActiveUid(section._uid)}
        >
          {section.title}
        </button>
      ))}
    </div>
  );
};
